import ChickenTableRow from "./ChickenTableRow";
import ChickenPredictionItem from "./ChickenPredictionItem";

export const ChickenTable = ({ image, items, images, imageUuid, predictionUuid }: { image: string, items: Array<object>, images: Array<string>, imageUuid: string, predictionUuid: string }) => {
	if (items.length == 0) {
		return (<div className="font-normal">No roosters found</div>);
	}

	let featureRooster = null;
	const roosters = [];

	// find the feature rooster
	for (const item of items) {
		if (item.attributes.id == predictionUuid) {
			featureRooster = item;
		} else {
			roosters.push(item);
		}
	}

	// if the initial uuid is null or no match found, pick the top item
	if (!featureRooster) {
		featureRooster = roosters.shift();
	}

	const prefixUrl = `/lookups/result/${imageUuid}`;

	return (
		<>
			<div>
				<ChickenPredictionItem image_url={image} chicken={featureRooster} feature_image_url={images[featureRooster.id]} />
			</div>
            {roosters.length > 1 ?
			<div className="overflow-x-auto rounded-box border border-base-content/5 bg-base-100">
				<table className="table">
					<thead>
						<tr>
						<th>Name</th>
						<th>Certainty</th>
						</tr>
					</thead>
					<tbody>
						{roosters.map((chicken: object) => (
							<ChickenTableRow chicken={chicken} image={images[chicken.id]} key={chicken.id} prefixUrl={prefixUrl} />
						))}
					</tbody>
				</table>
			</div>
            : <></>}
		</>
	);
};

export default ChickenTable;
